import { z } from "zod";

export const userProfileSchema = z.object({
  userId: z.string(),
  telegramId: z.string(),
  displayName: z.string(),
  username: z.string().nullable(),
  avatarUrl: z.string().nullable(),
  languageCode: z.string().nullable(),
  createdAt: z.string(),
});

export type UserProfileDTO = z.infer<typeof userProfileSchema>;

// GET /api/v1/me now returns the fuller PlayerProfileDTO (schemas/profile.ts) —
// profile + wallet + progression + streak + achievements + stats — superseding
// the old narrower MeResponse (profile + wallet only).
